import { createBroadcastBehaviorSubject } from './broadcast-behavior-subject';

export type CrosshairPriceSyncData = {
  time: number | null;
  price: number | null;
  sourceTimeframeIndex?: number;
  sourceTimeframe?: string; // e.g., "1m", "5m", "15m", "1h", "4h"
  sourceInstanceId?: string;
};

const crosshairPricePosition$ =
  createBroadcastBehaviorSubject<CrosshairPriceSyncData>(
    'chart-crosshair-price-sync',
    {
      time: null,
      price: null
    }
  );

export const getCrosshairPricePosition$ = () => {
  return crosshairPricePosition$.asObservable();
};

export const updateCrosshairPricePosition = (data: CrosshairPriceSyncData) => {
  crosshairPricePosition$.next({
    ...data,
    sourceInstanceId: crosshairPricePosition$.instanceId
  });
};

export const getCurrentPricePosition = (): CrosshairPriceSyncData => {
  return crosshairPricePosition$.getValue();
};

export const getCrosshairPriceSyncInstanceId = () =>
  crosshairPricePosition$.instanceId;
